import { createApi } from '@reduxjs/toolkit/query/react';
import reducerPath from "../../../../app/reducerPath";
import createHeadRequest from "../../../../shared/http/createHeadRequest";
import checkStatus from "../../../../shared/http/checkStatus";
import HttpMethods from "../../../../shared/api/HttpMethods";
import config from "../../../../shared/api/config";
import baseQueryWithReAuth from "../../../baseQueryWithReAuth/baseQueryWithReAuth";

export const apiTokensResourceApi = createApi({
  reducerPath: `${reducerPath.apiTokensResource}/api`,
  tagTypes: ['API_TOKENS'],
  baseQuery: (...arg) => baseQueryWithReAuth(...arg, `${config.baseUrl}/api-tokens`),
  endpoints: (builder) => ({
    getApiTokens: builder.query({
      query: () => ({
        ...createHeadRequest({ url: '', method: HttpMethods.GET }),
        validateStatus: checkStatus,
      }),
      providesTags: ['API_TOKENS'],
    }),
    createApiToken: builder.mutation({
      query: ({ name }) => ({
        ...createHeadRequest({ url: '', method: HttpMethods.POST }),
        body: { name },
        validateStatus: checkStatus,
      }),
      invalidatesTags: ['API_TOKENS'],
    }),
    deleteApiToken: builder.mutation({
      query: ({ id }) => ({
        ...createHeadRequest({ url: `/${id}`, method: HttpMethods.DELETE }),
        validateStatus: checkStatus,
      }),
      invalidatesTags: ['API_TOKENS'],
    }),
  }),
});

export const {
  useGetApiTokensQuery,
  useCreateApiTokenMutation,
  useDeleteApiTokenMutation,
} = apiTokensResourceApi;